<template>
  <div
    v-resize="() => path = buildPath()"
    v-bind:class="{ p: padWaveHeight, m: marginWaveHeight }"
    v-bind:style="{ 'clip-path': path }"
  >
    <slot />
  </div>
</template>


<style scoped>
.p {
  padding-top: 3vw;
}
.m {
  margin-top: -3vw;
}
</style>


<script>
function q(x, w, h) {
  return `Q${x+.25*w},${-.5*h} ${x+.5*w},${.5*h}Q${x+.75*w},${1.5*h} ${x+w},${.5*h}`;
}

export default {
  name: 'clip-waves',

  props: {
    offset: Number,
    padWaveHeight: Boolean,
    marginWaveHeight: Boolean
  },

  data() {
    return {
      path: null
    }
  },

  methods: {
    buildPath() {
      const w = innerWidth;
      const h = w * .03;
      return `path('M${this.offset*w-w},${.5*h}${q(this.offset*w-w, w, h)}${q(this.offset*w, w, h)}L${this.offset*w+w},999999L${this.offset*w-w},999999L${this.offset*w-w},${.5*h}Z')`
    }
  }
};
</script>
